import { render, staticRenderFns } from "./TassklistDetails.vue?vue&type=template&id=60d17cd4&scoped=true"
import script from "./TassklistDetails.vue?vue&type=script&lang=js"
export * from "./TassklistDetails.vue?vue&type=script&lang=js"
import style0 from "./TassklistDetails.vue?vue&type=style&index=0&id=60d17cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d17cd4",
  null
  
)

export default component.exports